(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/lyckoplatsen/map-static/map-static-map-handler.js') >= 0) return;  svs.modules.push('/components/tur/lyckoplatsen/map-static/map-static-map-handler.js');

'use strict';

var _svs, _svs$replace;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const cdn = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 || (_svs = _svs.cdn2) === null || _svs === void 0 || (_svs$replace = _svs.replace) === null || _svs$replace === void 0 ? void 0 : _svs$replace.call(_svs, '/content', '');
const {
  mapDefaults,
  createMap,
  getIconLeaflet
} = svs.tur.lyckoplatsen.map;
const getStaticMapHandler = () => {
  let map;
  let pin;
  return {
    createMap(_ref) {
      let {
        mapOptions,
        coord,
        charity,
        locationName,
        useSmallIcon,
        errorCallback
      } = _ref;
      const options = _objectSpread(_objectSpread(_objectSpread({}, mapDefaults), mapOptions), {}, {
        errorCallback
      });
      map = createMap(options);
      const heartPin = getIconLeaflet({
        color: 'red',
        useSmallIcon
      });
      pin = leaflet.marker(mapOptions.center, {
        icon: heartPin
      });
      pin.addTo(map);
      if (locationName) {
        let content = "<div class=\"break-word bold f-600 margin-0\">".concat(locationName, "</div>");
        if (charity) {
          content += "<img style=\"max-height: 54px;\" class=\"margin-top-1\" src=".concat(cdn + charity.logotypeId, " alt=").concat(charity.name, " />");
        }
        leaflet.popup({
          autoClose: false,
          closeButton: false,
          closeOnClick: false,
          minWidth: 130,
          maxWidth: 400
        }).setLatLng(coord).setContent(content).openOn(map);
      }
      return map;
    },
    removeMap() {
      if (map) {
        try {
          if (typeof map.closePopup === 'function') {
            const hasPopup = map._popup;
            if (hasPopup && typeof hasPopup.close === 'function') {
              map.closePopup();
            }
          }
        } catch (err) {
        }
        try {
          if (typeof map.closeTooltip === 'function') {
            const hasTooltip = map._tooltip;
            if (hasTooltip && typeof hasTooltip.close === 'function') {
              map.closeTooltip();
            }
          }
        } catch (err) {
        }
      }

      if (pin) {
        try {
          if (pin && pin.remove) {
            pin.remove();
          }
        } catch (err) {
        }
        pin = null;
      }

      if (map) {
        try {
          map.off();
          map.remove();
        } catch (err) {
        }
        map = null;
      }
    }
  };
};
Object.assign(svs.tur.lyckoplatsen.map, {
  getStaticMapHandler
});

 })(window);